import { CardActionArea, Stack } from '@mui/material'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { Link, useLocation } from 'react-router-dom'

interface Props {
  to?: string
  title: string
  place: string
  src: string
  time: string
  summary: string
}
export default function EventCard({
  to = '#',
  place,
  time,
  src,
  title,
  summary,
}: Props) {
  const urlQuery = new URLSearchParams(useLocation().search)
  return (
    <Card elevation={1}>
      <Link to={`${to}/?${urlQuery}`}>
        <CardActionArea>
          <CardContent>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={1}
              sx={{
                width: '100%',
              }}
            >
              <Stack
                sx={{
                  width: '60%',
                }}
              >
                <Typography
                  gutterBottom
                  variant="body1"
                  component="h4"
                  sx={{
                    width: '100%',
                    fontWeight: 'bold',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {title}
                </Typography>
                <Typography
                  variant="body2"
                  component="h5"
                  mb={1}
                  sx={{
                    width: '100%',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {place}
                </Typography>
                <Typography variant="body2" component="p" mb={1}>
                  {time}
                </Typography>
                <Typography
                  variant="body2"
                  component="p"
                  sx={{
                    height: 40,
                    display: '-webkit-box',
                    WebkitLineClamp: '2',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                >
                  {summary}
                </Typography>
              </Stack>
              <Stack
                sx={{
                  width: {
                    xs: '160px',
                    md: '200px',
                  },
                  height: {
                    xs: '120px',
                    md: '150px',
                  },
                  flex: 1,
                  '&>img': {
                    objectFit: 'contain',
                  },
                }}
              >
                <img
                  width="100%"
                  height="100%"
                  src={src}
                  alt={title}
                  loading="lazy"
                  crossOrigin="anonymous"
                />
              </Stack>
            </Stack>
          </CardContent>
        </CardActionArea>
      </Link>
    </Card>
  )
}
